























import {Component, Watch} from "vue-property-decorator"
import Navbar from "@/components/Navbar.vue" // @ is an alias to /src
import Footer from "@/components/Footer.vue"
import Sidebar from "@/components/Sidebar.vue"
import logger from "@/utils/logging"
import BaseVue from "@/utils/BaseVue"

@Component({
    components: {
        Navbar,
        Sidebar,
        Footer,
    },
})
export default class StoreDashboard extends BaseVue {

    private get isStoreLoading(): boolean {
        const storeData = this.$typedStore.state.stores[this.storeId]
        return storeData !== undefined && storeData.isLoading
    }

    private get loadingError(): { header: string, message: string } | null {
        const error = this.$typedStore.state.stores[this.storeId].error
        return error !== null ? {
            header: error.code === "not_found"
                ? "Det var ikke muligt at finde butikken"
                : "Hov, vi oplever et problem lige nu",
            message: error.code === "not_found"
                ? "Tjek venligst, om du har indtastet det rigtige kardex nr på butikken eller vælg en anden butik."
                : `Prøv venligst igen. En ukendt fejl er opstået: '${error.message}'`,
        } : null
    }

    private created() {
        // fetch the data when the view is created and the data is already being observed
        // tslint:disable no-string-literal
        this.onStoreIdChanged(Number(this.$route.params["storeId"]))
    }

    @Watch("$route.params.storeId")
    private onStoreIdChanged(storeId: number) {
        logger.debug(`Store changed to #${storeId}. Reloading data...`)
        this.$typedStore.actions.stores.loadStore(storeId)
    }

    private get storeId(): number {
        // tslint:disable no-string-literal
        return Number(this.$route.params["storeId"])
    }
}
